module.exports = __webpack_public_path__ + "static/media/sketch_03.7fb5cc62.png";